import Result from "@Totum/Main/Infrastructure/Result";
import { requestJson } from "@Totum/Main/Infrastructure/ServiceBase";
import { IGroupsMinimal, IUsersMinimal } from "../domain/types";

const API_URL = "/api/UserGroup";

/**
 * Fetches all groups.
 */
export const getUserGroups = async (): Promise<Result<{ subGroups: IGroupsMinimal[] }>> => {
    return await requestJson({
        url: `${API_URL}`,
        method: "GET",
    });
};

/**
 * Fetches a specific group by its ID.
 * @param groupId - The ID of the group to fetch.
 */
export const getUserGroup = async (groupId: string): Promise<Result<{ subGroups: IGroupsMinimal[] }>> => {
    return await requestJson<{ subGroups: IGroupsMinimal[] }>({
        url: `${API_URL}/${groupId}`,
        method: "GET",
    });
};

/**
 * Fetches a specific group's users by its ID.
 * @param groupId - The ID of the group to fetch.
 * @param page - The page number of the users to fetch
 * @param pageSize - The number of users
 * @param isGroupAdmin - Whether the user is a group admin
 */
export const getGroupUsers = async (
    groupId?: string,
    page: number = 0,
    pageSize: number = 10,
    searchTerm: string = "",
    isGroupAdmin: boolean = false
): Promise<Result<IUsersMinimal>> => {
    const params = `page=${page}&page-size=${pageSize}&search-term=${searchTerm}&is-group-admin=${isGroupAdmin}`;
    return await requestJson<IUsersMinimal>({
        url: `${API_URL}/${groupId}/users?${params}`,
        method: "GET",
    });
};

/**
 * Fetches a specific group's users by its ID.
 * @param page - The page number of the users to fetch
 * @param pageSize - The number of users
 * @param searchTerm - The number of users
 * @param isGroupAdmin - Whether the user is a group admin
 */
export const getUsers = async (
    page?: number,
    pageSize?: number,
    searchTerm?: string,
    isGroupAdmin?: boolean
): Promise<Result<IUsersMinimal>> => {
    const params = `page=${page}&page-size=${pageSize}&search-term=${searchTerm}&is-group-admin=${isGroupAdmin}`;
    return await requestJson<IUsersMinimal>({
        url: `${API_URL}/users?${params}`,
        method: "GET",
    });
};
